export const ProductType = {
    "offer": 0,
    "upsell": 1,
};

export const NavigationElementType = {
    "button": 0,
    "link": 1,
};
